import { createFileRoute, redirect } from '@tanstack/react-router'
import { PositionList } from '@/features/positions/position-list'
import { hasGrant } from '@/lib/me'

/**
 * Route shell for the positions screen.
 *
 * The grant gate is presentation only — the API enforces `company.view` on
 * the position endpoints; this only keeps a user without the grant out of a
 * screen they cannot use.
 */
export const Route = createFileRoute('/_authenticated/positions')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'company.view')) {
      throw redirect({ to: '/' })
    }
  },
  component: PositionList,
})
